// extracted by mini-css-extract-plugin
export default {"home":"Landing_home__ItBSj"};